<template>
    <div>
        <div class="columns">
            <div class="column">
                <h1 class="is-size-2 is-page-title">In de media</h1>
                <h1>PlattelandsTV - Ark van Noë - 2022</h1>
                <p>
                    In 2022 heeft het team van PlattelandsTV een vervolg reportage gemaakt over de Belgische Mastiff.
                </p>
                <a href="https://www.plattelandstv.be" target="_blank">www.plattelandstv.be</a>
                <video width="960" height="720" controls>
                    <source :src="platteland2022" type="video/mp4">
                    Uw browser ondersteunt geen video.
                </video>
            </div>
        </div>
        <div class="columns is-mobile is-centered">
          <router-link to="/media" class="is-page-read-more">Meer media</router-link>
        </div>
    </div>
</template>

<script>
export default {
    name: "Media",
    data: function() {
        return {
            platteland2022: process.env.VUE_APP_VIDEO_URL + '/plattelandstv-2022.mp4'
        }
    }
}
</script>

<style scoped>
    .is-page-read-more {
        margin-bottom: 4vh;
    }
    h1 {
        margin-top: 1em;
        color: #016F70;
        font-weight: 600;
        font-size: 1.3em;
    }
</style>